import { OrderItem } from '@lentau/order/shared/models/interfaces';
import { ANALYTIC_EVENT_EVENTS, ANALYTIC_EVENT_LABELS, ANALYTIC_EVENT_TYPES, ECOMMERCE } from '../../constants';
import { OrderGTMArgs, OrderItemEventGTM, OrderItemPurchaseGTM } from '../../events-interfaces';
import { isValidArrayData } from '@lentau/ui-kit/core/utils/array.utils';
import { withSeparator } from '@lentau/ui-kit/core/utils/miscellaneous/with-separator';

type GroupedItem = {
  item: OrderItem;
  groupSize: number;
};

export const getOrderItemGTM = (id: string, price: number, quantity: number): OrderItemEventGTM => ({
  id,
  price,
  quantity,
});

export const getOrderItemPurchaseGTM = (
  id: string,
  price: number,
  quantity: number,
  orderItem: OrderItem
): OrderItemPurchaseGTM => ({
  ...getOrderItemGTM(id, price, quantity),
  name: orderItem.Name,
  brand: '',
  category: '',
});

const groupItemsById = (items: OrderItem[]): GroupedItem[] => {
  const groups: Map<string, GroupedItem> = new Map();

  for (const item of items) {
    const group = groups.get(item.Id);
    groups.set(item.Id, {
      item: group?.item ?? item,
      groupSize: (group?.groupSize ?? 0) + 1,
    });
  }

  return Array.from(groups.values());
};

const getGTMProducts = (orderItems: OrderItem[]): OrderItemPurchaseGTM[] => {
  if (!isValidArrayData(orderItems)) return [];

  return groupItemsById(orderItems)
    .filter(({ item, groupSize }) => {
      const isSingleItem = groupSize === 1;
      const isZeroQuantity = Number(item.Quantity) === 0;

      return !(isSingleItem && isZeroQuantity);
    })
    .map(({ item }) => {
      const finalQuantity = Number(item.QuantityOrigin);

      return getOrderItemPurchaseGTM(item.Id, item.Price, finalQuantity, item);
    });
};

export const getCreateOrderGTM = ({
  order,
  orderItems,
  isLeaveUnderDoorEnabled,
  isDontCallDoorEnabled,
}: OrderGTMArgs) => {
  const products: OrderItemPurchaseGTM[] = getGTMProducts(orderItems);

  const leaveUnderDoor: string = isLeaveUnderDoorEnabled ? `${order?.LeaveUnderDoor ?? ''}` : '';
  const dontCallDoor: string = isDontCallDoorEnabled ? `${order?.DontCallDoor ?? ''}` : '';

  return {
    event: ANALYTIC_EVENT_TYPES.OWOX,
    eventCategory: ECOMMERCE,
    eventAction: ANALYTIC_EVENT_EVENTS.legacyCheckout,
    eventLabel: ANALYTIC_EVENT_LABELS.purchase,
    eventContent: withSeparator([dontCallDoor, leaveUnderDoor]),
    firstPurchaseFlag: Boolean(order?.FirstOrder),
    ecommerce: {
      purchase: {
        actionField: {
          id: order.Id, // Номер заказа
          affiliation: 'new', // 'new' - Не меняется
          revenue: `${order.GoodsCost}`, // Стоимость заказа
          shipping: String(order.DeliveryPrice ?? 0), // Стоимость доставки вида "ХХХ.YY", если бесплатно - "0"
        },
        products,
      },
    },
  };
};
